import React, { useState } from "react";
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Button,
  Input,
} from "reactstrap";

const InviteCodeModal = ({ open, setOpen, onInviteCode }) => {
  const [loading, setLoading] = useState(false);
  const [inviteCode, setInviteCode] = useState("");

  const toggleModal = () => {
    setOpen(!open);
  };

  const handlePostInviteCode = async () => {
    setLoading(true);
    await onInviteCode(inviteCode);
    setLoading(false);
  };

  return (
    <Modal isOpen={open} toggle={toggleModal}>
      <ModalHeader toggle={toggleModal}>
        <h3 className="mb-0">Use an Invite Code</h3>
      </ModalHeader>
      <ModalBody>
        <Input
          type="text"
          value={inviteCode}
          placeholder="Enter Invite Code"
          onChange={(e) => setInviteCode(e.target.value)}
        />
      </ModalBody>
      <ModalFooter>
        <Button
          onClick={handlePostInviteCode}
          color="primary"
          disabled={loading}
        >
          {loading ? (
            <span
              className="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
          ) : (
            "Submit"
          )}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default InviteCodeModal;
